export interface IComplianceLog {
    centerId: number,
    centerName: string,
    logDate: string,

    centerItemsChecked: number,
    centerItemsFailed: number,

    recipientCount: number,
    recipientItemsChecked: number,
    recipientItemsFailed: number,

    postTxpRecipientCount: number,
    postTxpRecipientItemsChecked: number,
    postTxpRecipientItemsFailed: number,

    donorCount: number,
    donorItemsChecked: number,
    donorItemsFailed: number,

    postTxpDonorCount: number,
    postTxpDonorItemsChecked: number,
    postTxpDonorItemsFailed: number,

    rexmCount: number,
    rexmItemsChecked: number,
    rexmItemsFailed: number,

    pendingRemoteStatusCount: number,

    rexmPercent: number,
    centerPercent: number,
    recipientPercent: number,
    postTxpRecipientPercent: number,
    donorPercent: number,
    postTxpDonorPercent: number,

    overallChecked: number,
    overallFailed: number,
    overallPercent: number
}